module.exports = __webpack_public_path__ + "static/media/normal.fc493128.svg";